
export const userKey = '__floresta_user';
export const mainMenu = '__floresta_main_menu';
// export const baseApiUrl = 'http://localhost:8081/api';
// export const baseApiUrl = 'https://ecommerce.florestaimport.com.br/api';
// export const baseApiUrl = 'http://localhost:22056/api';
// export const baseImage = 'https://ecommerce.florestaimport.com.br/Image/';
// export const baseImage = 'http://localhost:22056/Image/';

// export const baseApiUrl = 'http://floresta.mave.run/api';
// export const baseImage = 'http://floresta.mave.run/Image/';

export const baseApiUrl = 'https://pedidos.florestaltda.com.br/sys/api/';
export const baseImage = 'https://pedidos.florestaltda.com.br/Image/';

export default { baseApiUrl, userKey, mainMenu, baseImage}